import Paper from '@mui/material/Paper';
import { Box, Typography } from '@mui/material';
import { convertTimeStamp } from '../../../../utilities/helpers';
import { TableRow, TableBody, TableCell, TableHead } from '@mui/material';
import Table from '@mui/material/Table';
import useStyles from '../NetworkData/styles';
import useCommonStyles from '../../../../commonStyles';

/**
 * @name AdUnitAndFloorPriceHistory
 * @description This component displays the history of ad units and floor prices.
 * @param {Object} props - The component props.
 * @param {Array} props.fvpVastTagHistory - The history of VAST tags.
 * @param {Function} props.showHistoricalAdUnitDetails - Function to show historical ad unit details.
 */
const AdUnitAndFloorPriceHistory = ({ fvpVastTagHistory, showHistoricalAdUnitDetails }) => {
	const classes = useStyles();
	const commonStyleClasses = useCommonStyles();

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle} style={{ marginTop: '4rem' }}>
			<Box>
				<Typography
					variant="h5"
					fontWeight={600}
					style={{
						width: 'fit-content',
						textAlign: 'center',
						margin: '3rem auto'
					}}
				>
					Ad Units & Floor Price History
				</Typography>
			</Box>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell width={'60%'}>
							<Typography fontWeight={800}>AD UNIT</Typography>
						</TableCell>
						<TableCell>
							<Typography fontWeight={800}>FLOOR PRICE</Typography>
						</TableCell>
						<TableCell>
							<Typography fontWeight={800}>TIMESTAMP (UTC)</Typography>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{fvpVastTagHistory &&
						fvpVastTagHistory.map((adUnitObj) => {
							const convertedTimestamp = convertTimeStamp(adUnitObj.timestamp);
							return (
								<TableRow
									style={{ cursor: 'pointer' }}
									hover
									onClick={() => showHistoricalAdUnitDetails(adUnitObj)}
									key={adUnitObj.adUnitName}
								>
									<TableCell>
										<Typography variant="p" fontWeight="bold" className={classes.subHeading}>
											{adUnitObj.adUnitName}
										</Typography>
									</TableCell>
									<TableCell>
										<Typography variant="p" fontWeight="bold" className={classes.subHeading}>
											{adUnitObj.floorPrice}
										</Typography>
									</TableCell>
									<TableCell>
										<Typography variant="p" fontWeight="bold" className={classes.subHeading}>
											{`${convertedTimestamp.date} , ${convertedTimestamp.time}`}
										</Typography>
									</TableCell>
								</TableRow>
							);
						})}
				</TableBody>
			</Table>
		</Paper>
	);
};

export default AdUnitAndFloorPriceHistory;
